import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { fetchCmsGlobals } from "./appGlobalShellCache";
import type { CmsGlobals } from "./cmsGlobals.types"; 

const CmsGlobalsCtx = createContext<{
  globals: CmsGlobals | null;
  loading: boolean;
  error: string | null;
}>({ globals: null, loading: true, error: null });

export function CmsGlobalsProvider({ children }: { children: ReactNode }) { //NOSONAR
  const [globals, setGlobals] = useState<CmsGlobals | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    setLoading(true);
    setError(null);

    fetchCmsGlobals(controller.signal)
      .then(setGlobals)
      .catch((err) => {
        if (err?.code === "ERR_CANCELED" || err?.name === "CanceledError") return;
        setError(err?.message ?? "Failed to load globals");
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, []);

  return (
    <CmsGlobalsCtx.Provider 
      value={{ globals, loading, error }} //NOSONAR
    > 
      {children}
    </CmsGlobalsCtx.Provider>
  );
}

export const useCmsGlobals = () => useContext(CmsGlobalsCtx);
